import { websocket } from '@hh.ru/chatik-integration/lib/Websocket';
import urlParser from 'bloko/common/urlParser';

import Components from 'HHC/Components';

const USER_FORCE_LOGOUT_EVENT = 'user_force_logout';

const ForceLogoutEventListener = () => {
    websocket.on(USER_FORCE_LOGOUT_EVENT, (eventData) => {
        const url = urlParser('/account/force_logout');
        url.params = {
            reason: eventData.forceLogoutReason,
            backUrl: window.location.href,
        };
        window.location.href = url.href;
    });
};

export default Components.build({
    create: ForceLogoutEventListener,
});
